/** Reward conversion only. Path coins cannot be exchanged back into paid diamonds. */
export const PATH_COINS_PER_DIAMOND = 10;
export const rewardPathCoins = (legacyDiamonds) => {
    if (!Number.isSafeInteger(legacyDiamonds) || legacyDiamonds < 0)
        throw new RangeError('Invalid reward amount');
    const coins = legacyDiamonds * PATH_COINS_PER_DIAMOND;
    if (!Number.isSafeInteger(coins))
        throw new RangeError('Reward overflow');
    return coins;
};
export const REFERRAL_PATH_COINS = rewardPathCoins(2);
export const VIP_PASS_PATH_COINS = rewardPathCoins(525);
